module.exports = __webpack_public_path__ + "img/russellhall-h-474x356.e298e6c0.jpg";